import { render, staticRenderFns } from "./RulesBuilder.vue?vue&type=template&id=459ad49d"
import script from "./RulesBuilder.vue?vue&type=script&lang=js"
export * from "./RulesBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports